import React from "react";
import { useRecoilState, useRecoilValue } from "recoil";
import styled from "styled-components";
import { Categories, categoriesState, categoryState } from "../../atoms";

const CategoryList = styled.button`
border: none;
border-radius: 0.5rem;
  background-color: #cfc4ff;
  padding: 0.5rem;
  margin:0.5rem;

`

const Lists = styled.div`
  display: flex;
  padding: 0.5rem;
    margin-bottom: 20px;
    border-bottom: 1px solid #F2F2F2;
    align-items: center;
    flex-direction: column;
`


const CategoriesText = styled.div`
  display: flex;
  padding: 0.5rem;
  margin-bottom:1rem;
  border-bottom: 0.1rem dashed #9b1111;

`

const ShowCategoryList = () => {
  const [currentCategory, setCategory] = useRecoilState(categoryState);
  const categories = useRecoilValue(categoriesState)
  const handleClick = (category: Categories | string) => {
    setCategory(category);
  };
  return (
    <Lists>
      <CategoriesText>My Categories</CategoriesText>
      <div>
      <CategoryList className={currentCategory === Categories.TO_DO ? 'active' : ''} onClick={() => { handleClick(Categories.TO_DO) }}>할 일</CategoryList>
      <CategoryList className={currentCategory === Categories.DOING ? 'active' : ''} onClick={() => { handleClick(Categories.DOING) }}>하는 중</CategoryList>
      <CategoryList className={currentCategory === Categories.DONE ? 'active' : ''} onClick={() => { handleClick(Categories.DONE) }}>완료</CategoryList>
      {categories.map((category) => (<CategoryList className={currentCategory === category ? 'active' : ''} key={category} onClick={() => { handleClick(category) }}>{category}</CategoryList>))}
      </div>
    </Lists>
  )
}

export default ShowCategoryList